import { sendDataLayerEvent } from '../../utils/dataLayerInteractions';
import EventNamesType from '../eventNamesType';

export type StoreLocatorDataType = {
  postcode: string;
  step: 'list' | 'details';
};

export function sendStoreLocatorEvent(storeLocatorData: StoreLocatorDataType) {
  sendDataLayerEvent(EventNamesType.store_locator, {
    custom_data: {
      ...storeLocatorData,
    },
  });
}
